import { createContext } from 'react';
import { assign, createMachine } from "xstate";


//models
import { User } from '../models/User';


export const sesionMachine = createMachine({
    id: "sesionDataFetch",
    initial: "unauthorized",
    context: { user: null, rol:"none"} as {user: User | null, rol: string},
    states: {
      unauthorized: {
        entry: assign({
        user: () => null,
        rol: () => "none"
        }),
        on: {
            VERIFYYING: { target: "verifying"  },
        },
      },
      verifying: {
        on: {
            AUTHORIZED: { target: "authorized"  },
            UNAUTHORIZED: { target: "unauthorized"  },
        },
      },
      authorized: {
        entry: assign({
        // Desestructuramos el evento para obtener los datos
        user: ({ event }) => event.data?.user,
        rol: ({ event }) => event.data?.user?.role
      }),
        on: {
            UNAUTHORIZED: { target: "unauthorized"  },
        },
      },
    },
  }, 
);

export const PromiseSesionContext = createContext<any>({});